import { render } from "./commonComponent.vue?vue&type=template&id=4a21d83b&scoped=true"
import script from "./commonComponent.vue?vue&type=script&lang=js"
export * from "./commonComponent.vue?vue&type=script&lang=js"

import "./commonComponent.vue?vue&type=style&index=0&id=4a21d83b&scoped=true&lang=css"

import exportComponent from "F:\\CS\\Projectsdatabases\\madienty-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a21d83b"]])

export default __exports__